<template>
  <div class="location-information-container">
    <custom-skeleton-loader :LoadingFlag="SkeletonLoadingFlag" />
    <div v-if="!SkeletonLoadingFlag">
      <div v-if="Records.CityId > 0" class="location-details-content">
        <div class="info-row">
          <div class="info-icon">
            <v-icon>mdi-map-check</v-icon>
          </div>
          <div class="info-content">
            <div class="info-label">State</div>
            <div class="info-value">{{ Records.StateName }}</div>
          </div>
        </div>

        <div class="info-row">
          <div class="info-icon">
            <v-icon>mdi-city</v-icon>
          </div>
          <div class="info-content">
            <div class="info-label">District</div>
            <div class="info-value">{{ Records.DistrictName }}</div>
          </div>
        </div>

        <div class="info-row">
          <div class="info-icon">
            <v-icon>mdi-home-city</v-icon>
          </div>
          <div class="info-content">
            <div class="info-label">City</div>
            <div class="info-value">{{ Records.CityName }}</div>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">
        <div class="empty-icon">
          <v-icon size="64">mdi-map-outline</v-icon>
        </div>
        <h3 class="empty-title">Location Not Updated</h3>
        <p class="empty-description">Please update location details to proceed</p>
        <v-btn
          class="update-btn"
          @click.prevent="updatePrompt = true"
        >
          <v-icon left>mdi-pencil</v-icon>
          Update Location
        </v-btn>
      </div>

      <v-dialog v-model="updatePrompt" persistent max-width="70%">
        <location-information-update
          @hideupdatePrompt="hideupdatePrompt"
          v-if="updatePrompt"
        ></location-information-update>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import LocationInformationUpdate from "./LocationInformationUpdate.vue";

export default {
  mixins: [common],
  components: {
    LocationInformationUpdate,
  },
  data() {
    return {
      Records: {},
      updatePrompt: false,

      SkeletonLoadingFlag: true,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      CurrentYearId: "",
    };
  },
  mounted() {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "jci_india_lom",
        Action: "list_2",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getLocationRecords();
    },
    hideupdatePrompt() {
      console.log("hideupdatePrompt called");
      this.updatePrompt = false;
      this.getLocationRecords();
    },
    getLocationRecords() {
      console.log("getLocationRecords is called");

      this.SkeletonLoadingFlag = true;
      this.rows = [];
      this.zone = {};
      this.lom = {};

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/lom/show";
      var upload = {
        UserInterface: 2,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.SkeletonLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          console.log("output=" + output + ", flag=" + flag);

          records = response.data.records;
          console.log({ records });

          if (flag == 1) {
            thisIns.Records = response.data.records;
            console.log("Records=" + JSON.stringify(thisIns.Records));
            // thisIns.toast("success", output);
          } else {
            // thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SkeletonLoadingFlag = false;
        });
    },
  },
  mounted() {},
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.location-information-container {
  width: 100%;

  .location-details-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 14px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.05) 0%, rgba(0, 151, 215, 0.03) 100%);
    border-radius: 12px;
    border-left: 4px solid #0097d7;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(135deg, rgba(58, 103, 177, 0.1) 0%, rgba(0, 151, 215, 0.08) 100%);
      transform: translateX(4px);
    }
  }

  .info-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #0097d7 0%, #00a8e8 100%);
    border-radius: 10px;
    color: white;
    font-size: 20px;
  }

  .info-content {
    flex: 1;
  }

  .info-label {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  .info-value {
    font-size: 15px;
    font-weight: 500;
    color: #333;
    word-wrap: break-word;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 40px 20px;
    background: linear-gradient(135deg, #f0f4f8 0%, #f8fafc 100%);
    border-radius: 14px;
    border: 2px dashed #0097d7;
    text-align: center;
  }

  .empty-icon {
    color: #0097d7;
    opacity: 0.6;
  }

  .empty-title {
    font-size: 18px;
    font-weight: 700;
    color: #0a0f29;
    margin: 0;
  }

  .empty-description {
    font-size: 13px;
    color: #666;
    margin: 0;
  }

  .update-btn {
    background: linear-gradient(135deg, #0097d7 0%, #00a8e8 100%) !important;
    color: white !important;
    padding: 10px 24px !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: all 0.3s ease !important;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 151, 215, 0.3);
    }
  }
}
</style>
<style>
</style>
